import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@/components/common/TextInput';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  handleMerchandiseMetadata: (field: string, value: string) => void;
};

export default function ProductDescriptionFormGroup({
  album,
  readonly,
  disabled,
  handleMerchandiseMetadata,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('product.editProduct.productDescription')}
        handleInput={(e) => {
          handleMerchandiseMetadata('productDescription', e.target.value);
        }}
        id="productDescription"
        type="text"
        value={album.merchandiseMetadata?.productDescription ?? ''}
        inputClassname="form-control"
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
      />
    </div>
  );
}
